import React, {Component} from 'react'
import {Link} from 'react-router-dom'
import styles from 'procedureStatuses/eGov/PrepareModal.scss'
import Modal from 'react-modal'
import {Close} from 'jbc-front/components/icons'
import {connect} from 'react-redux'
import ListGroup from 'jbc-front/components/ListGroup'

class PrepareModal extends Component {
  componentDidUpdate(prevProps) {
    if (this.props.isOpen !== prevProps.isOpen) {
      if (this.props.isOpen) {
        document.body.style.overflow = 'hidden'
      } else {
        document.body.style.overflow = ''
      }
    }
  }

  componentWillUnmount() {
    document.body.style.overflow = ''
  }

  hideModal = () => {
    const {hideModal} = this.props
    hideModal()
  }

  procedureDisableReason = (eGovInfo) => {
    const {eGovProcedures} = this.props
    const {procedure_code, csv_procedure_codes, errors = []} = eGovInfo

    const eGovProcedure = eGovProcedures?.find(
      ({procedure_code: pc}) => pc === procedure_code || csv_procedure_codes.includes(pc)
    )
    if (eGovProcedure && eGovProcedure.status !== 'inadequacy_error') {
      return '既に申請済みです'
    }
    if (errors.length) {
      return (
        <div className={styles.disabledReason}>
          {errors.map((error, index) => (
            <p key={index}>{error}</p>
          ))}
        </div>
      )
    }
    return false
  }

  render() {
    const {isOpen, eGovInformations, procedureStatusId} = this.props

    return (
      <React.Fragment>
        <Modal className={styles.modal} isOpen={isOpen} overlayClassName={styles.overlay} contentLabel="Modal">
          <div className={styles.header}>
            <div className={styles.title}>電子申請可能な書類</div>
            <div className={styles.tools}>
              <Close className={styles.close} onClick={this.hideModal} />
            </div>
          </div>
          <div className={styles.selectBody}>
            <h5>電子申請する書類を選択してください</h5>
            <ListGroup>
              {eGovInformations.map((info) => {
                const disabled_reason = this.procedureDisableReason(info)
                const disabled = !!disabled_reason
                return (
                  <ListGroup.Item
                    as={disabled ? 'div' : Link}
                    key={info.procedure_code}
                    disabled={disabled}
                    disabledReason={disabled_reason}
                    to={
                      disabled
                        ? undefined
                        : `/procedure_statuses/${procedureStatusId}/egov/prepare?procedure_code=${info.procedure_code}`
                    }
                  >
                    <span className={styles.reportName}>{info.name}</span>
                    {!disabled && <ListGroup.Icon />}
                  </ListGroup.Item>
                )
              })}
            </ListGroup>
          </div>
        </Modal>
      </React.Fragment>
    )
  }
}

export default connect((state) => ({
  procedureStatusId: state.procedureStatuses.current.data.id,
  eGovInformations: state.procedureStatuses.current.data.egov_informations,
  eGovProcedures: state.procedureStatuses.current.data.egov_procedure_statuses,
}))(PrepareModal)
